import React from "react";
import { Button } from "primereact/button";

const SKIP_FILTER_KEYS = new Set([
  "transactionType",
  "typeProperty",
  "center",
  "radius",
  "selectedPlace",
]);

export function countActiveFilters(filters = {}) {
  return Object.entries(filters).filter(([key, value]) => isVisibleFilter(key, value)).length;
}

function isVisibleFilter(key, value) {
  if (SKIP_FILTER_KEYS.has(key)) return false;
  if (value === null || value === undefined || value === "" || value === false) return false;
  if (Array.isArray(value) && value.length === 0) return false;
  return true;
}

const ActiveFilters = ({ filters, onRemoveFilter }) => {
  const getFilterLabel = (key, value) => {
    const labels = {
      minRooms: value !== null ? `Ambientes desde ${value}` : "",
      maxRooms: value !== null ? `Ambientes hasta ${value}` : "",
      minBedrooms: value !== null ? `Dormitorios desde ${value}` : "",
      maxBedrooms: value !== null ? `Dormitorios hasta ${value}` : "",
      minBathrooms: value !== null ? `Baños desde ${value}` : "",
      maxBathrooms: value !== null ? `Baños hasta ${value}` : "",
      minPrice: `Desde ${value}`,
      maxPrice: `Hasta ${value}`,
      currency: `Moneda: ${value}`,
      hasPool: value ? "Pileta" : "",
      hasGrill: value ? "Parrilla" : "",
      hasGarden: value ? "Jardín" : "",
      hasTerrace: value ? "Terraza" : "",
      hasBalcony: value ? "Balcón" : "",
      minSquareMetersCovered: value !== null ? `m² Cubiertos desde ${value}` : "",
      maxSquareMetersCovered: value !== null ? `m² Cubiertos hasta ${value}` : "",
      minSquareMetersTotal: value !== null ? `m² Totales desde ${value}` : "",
      maxSquareMetersTotal: value !== null ? `m² Totales hasta ${value}` : "",
      expenses: `Expensas: ${value === 200001 ? "200.000+" : `0-${value}`}`,
      minAntiquity: value !== null ? `Antigüedad desde ${value} años` : "",
      maxAntiquity: value !== null ? `Antigüedad hasta ${value} años` : "",
      ownerType: value ? `Propietario: ${value === 'directo' ? 'Directo' : 'Inmobiliaria'}` : "",
      minParking: value !== null ? `Cochera desde ${value}` : "",
      searchValue: value ? `Ubicación: ${value}` : "",
    };
    return labels[key] || (typeof value === 'boolean' ? '' : value.toString());
  };

  const visible = Object.entries(filters).filter(([key, value]) => isVisibleFilter(key, value));
  if (visible.length === 0) return null;

  return (
    <div className="active-filters" aria-label="Filtros aplicados">
      {visible.map(([key, value]) => {

        return (
          <div key={key} className="filter-chip">
            <span>{getFilterLabel(key, value)}</span>
 
          <Button
              type="button"
              icon="pi pi-times"
              aria-label={`Quitar ${getFilterLabel(key, value)}`}
              className="p-button-text"
              onClick={() => onRemoveFilter(key)}
            /> 
           
          </div>
        );
      })}
    </div>
  );
};

export default ActiveFilters;
